<template>
    <div class="view view__lms_superadmin_users_bulk_add">
        <lms-superadmin-users-bulk-add/>
    </div>
</template>

<script>
import LmsSuperadminUsersBulkAdd from '@/components/lms/superadmin/users/bulk/add/LmsSuperadminUsersBulkAdd'
import { allowRedirectBeforeRouteLeave } from '@/helpers/mixins'

export default {
  name: 'view-lms-superadmin-users-bulk-add',
  components: { LmsSuperadminUsersBulkAdd },
  mixins: [allowRedirectBeforeRouteLeave],
  methods: {
    clearUsers () {
      this.$store.dispatch('lmsSuperadminUsersBulkClear')
    }
  },
  created () {
    this.$eventBus.$on('user-bulk-invite-submit', this.allowRedirect)
    this.clearUsers()
  },
  beforeDestroy () {
    this.$eventBus.$off('user-bulk-invite-submit', this.allowRedirect)
  }
}
</script>
